import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import Breadcrumb from "../common/breadcrumb";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  getCurrentLanguage,
  formatPrice,
} from "../../store";
import { customPostCall, getCall, patchCall, postCall } from "../../api/post";
import { payment } from "../../api/payment";
import {
  getNotificationCounter,
  isInquiryOrCart,
  setHeaderCounters,
} from "../../actions";
import { CheckoutProvider, Checkout } from "paytm-blink-checkout-react";
import { paytmConfigure } from "./paytm_config";
import { GooglePayConfigure } from "./goople_pay_config";
import PaypalExpressBtn from "react-paypal-express-checkout";
import GooglePayButton from "@google-pay/button-react";
import {
  getSettingUrl,
  getShippingOptionsUrl,
  getMerchantInformationUrl,
  getPaymentDetailsUrl,
  getOrderViaWhatsAppUrl,
  getGroupWiseGSTConfigurationUrl,
  getPincodeDeliveryUrl,
  getMasterDetailsIdUrl,
  getAddressDetailUrl,
  getSadadPaymentChecksumUrl,
  getServiceChargesUrl,
} from "../../services";
import AddBillingAddressModal from "./AddBillingAddressModal";
import EditBillingAddressModal from "./EditBillingAddressModal";
import MainLoader from "../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../animation/SuccessMessageAnimationModal";
import {
  clearLocalStorageReload,
  getCurrentDate,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../utils/utils";
import { withRouter } from "react-router-dom";
import { sadadPaymentConfigure } from "./sadad_config";
import SadadPaymentForm from "./SadadPaymentForm";
import { Modal } from "antd";
import "antd/dist/antd.css";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const SSR_SIMULATE = "SSR Simulate : ";

class checkOut extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cartList: [],
      isLoading: true,
      merchantInfo: {},
      isMerchantGSTEnable: false,
      shippingCharges: [],
      paymentDetails: [],
      paymentMethod: "Cash On Delivery",
      groupWiseGSTINConfig: [],
      paytmConfig: {},
      showCheckout: false,
      openInPopup: true,
      checkoutJsInstance: null,
      textAreaValue: "",
      isPlaceOrderButtonDisable: false,
      payUMoneyConfig: {},
      payPalConfig: {},
      googlePayConfig: {},
      isPaymentDone: false,
      AppTitle: "",
      currentCatelogueType: {},
      isPincodeDeliveryEnable: false,
      userDetails: {},
      showErrorMessageModal: false,
      errorMessage: "",
      showSuccessMessageModal: false,
      successMessage: "",
      masterDetailsObj: {},
      sadadPaymentChecksum: "",
      sadadPaymentConfig: {},
      isOpenPayWithSadad: false,
      isHidePlaceOrderButton: true,
      selectedShippingAddressId: null,
      showConfirmOrderDialog: false,
    };
  }

  componentDidMount() {
    console.log("=== CHECKOUT COMPONENT MOUNTING ===");
    const userDetails = loadUserDetailsFromLocalStorage();
    console.log("User details from localStorage:", userDetails);

    if (isOpenStoreIdExist() && userDetails === undefined) {
      console.log("Redirecting to login - no user details found");
      // Save redirect path and send user to plain login route
      localStorage.setItem("postLoginRedirect", "/checkout");
      navigateTo(this.props, `/login`);
      return;
    }

    console.log("Starting initialization sequence...");
    this.initMasterDetailsId().then(() => {
      console.log(
        "Master details initialized, starting other initializations..."
      );
      const { masterDetailsObj } = this.state;
      console.log("Master details object:", masterDetailsObj);

      this.initCartList().then(() => {
        console.log("Cart list initialized, setting loading to false");
        this.setState({ isLoading: false });
      });

      console.log("Initializing payment details...");
      this.initPaymentDetails();

      console.log("Initializing other components...");
      this.initMerchantInfo();
      this.initOrderViaWhatsApp();
      this.initShippingCharges();
      this.initServiceCharges();
      this.initGroupWiseGSTINConfig();
      this.initCatelogueSettings();
      this.initPincodeDelivery();
      this.initUserDetails();
      this.props.notificationCounter();
      this.props.isInquiryOrCart(masterDetailsObj);
      this.initBillingShippingAddressConfig();

      console.log("All initialization methods called");
    });
    console.log("=== CHECKOUT COMPONENT MOUNTING END ===");
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initCartList = async () => {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      return;
    }
    const { id } = userDetails;
    const cartListUrl = `orders?filter[where][userId]=${id}&filter[where][inshoppingcart]=${1}&filter[order]=created`;

    const cartList = await getCall(cartListUrl, []);
    if (cartList.error) {
      clearLocalStorageReload({ response: cartList });
      this.loadErrorMessageAnimation(cartList.error.message);
      if (cartList.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      if (cartList.length === 0) {
        this.props.history.push("/");
        return;
      }

      // Debug: Log cart structure
      console.log("Cart data structure:", cartList);
      if (cartList[0]) {
        console.log("First cart item:", cartList[0]);
        console.log("Has orderdetail:", !!cartList[0].orderdetail);
        console.log("Has orderdetails:", !!cartList[0].orderdetails);
      }

      this.setState({ cartList });
    }
  };

  fetchHeaderCounters = async () => {
    try {
      const response = await getCall("v2/dashboard/header-counters", []);
      if (response.error) {
        return;
      }
      this.props.setHeaderCounters(response); // <-- dispatch to Redux
    } catch (e) {}
  };

  initPaymentDetails = async () => {
    console.log("=== PAYMENT DETAILS INITIALIZATION START ===");
    const { masterDetailsObj } = this.state;
    console.log("Master Details Object:", masterDetailsObj);

    const paymentDetailsUrl = getPaymentDetailsUrl(masterDetailsObj);
    console.log("Payment Details URL:", paymentDetailsUrl);

    console.log("Making API call to fetch payment details...");
    const paymentDetails = await getCall(paymentDetailsUrl, []);

    if (paymentDetails.error) {
      console.error("=== PAYMENT DETAILS ERROR ===");
      console.error("Error fetching payment details:", paymentDetails.error);
      clearLocalStorageReload({ response: paymentDetails });
      this.loadErrorMessageAnimation(paymentDetails.error.message);
    } else {
      console.log("=== PAYMENT DETAILS SUCCESS ===");
      console.log("Raw Payment Details Response:", paymentDetails);

      if (paymentDetails && paymentDetails.length > 0) {
        console.log("Payment Details Array Length:", paymentDetails.length);
        console.log("Payment Details[0]:", paymentDetails[0]);
        console.log("Payment Details[0].status:", paymentDetails[0].status);
        console.log("Payment Details[0].text:", paymentDetails[0].text);
        console.log(
          "Payment Details[0].text type:",
          typeof paymentDetails[0].text
        );
        console.log("Is Array:", Array.isArray(paymentDetails[0].text));

        // Handle case where text might be a JSON string
        if (
          paymentDetails[0].text &&
          typeof paymentDetails[0].text === "string"
        ) {
          try {
            console.log("Parsing text as JSON string...");
            const parsedText = JSON.parse(paymentDetails[0].text);
            paymentDetails[0].text = parsedText;
            console.log("Successfully parsed text:", parsedText);
          } catch (error) {
            console.error("Failed to parse text as JSON:", error);
          }
        }

        // Log each payment method
        if (Array.isArray(paymentDetails[0].text)) {
          console.log("=== PAYMENT METHODS ANALYSIS ===");
          console.log(
            "Total payment methods found:",
            paymentDetails[0].text.length
          );

          paymentDetails[0].text.forEach((method, index) => {
            console.log(`Payment Method ${index + 1}:`, {
              name: method.name,
              status: method.status,
              paymenttype: method.paymenttype,
              config: method.config,
            });

            if (method.status === 1) {
              console.log(`✅ ENABLED: ${method.name}`);
            } else {
              console.log(`❌ DISABLED: ${method.name}`);
            }
          });

          // Filter enabled methods
          const enabledMethods = paymentDetails[0].text.filter(
            (method) => method.status === 1
          );
          console.log("=== ENABLED PAYMENT METHODS ===");
          console.log("Count:", enabledMethods.length);
          console.log(
            "Methods:",
            enabledMethods.map((m) => m.name)
          );

          if (enabledMethods.length === 0) {
            console.warn("⚠️ WARNING: No payment methods are enabled!");
          }
        }
      } else {
        console.warn("⚠️ WARNING: No payment details found in response");
      }

      console.log("Setting payment details in state...");
      this.setState({ paymentDetails }, () => {
        console.log("Payment details state updated successfully");
        console.log(
          "Current payment details state:",
          this.state.paymentDetails
        );
      });
    }
    console.log("=== PAYMENT DETAILS INITIALIZATION END ===");
  };

  initShippingCharges = async () => {
    const { masterDetailsObj } = this.state;
    const shippingChargesUrl = getShippingOptionsUrl(masterDetailsObj);
    const shippingCharges = await getCall(shippingChargesUrl, []);
    if (shippingCharges.error) {
      clearLocalStorageReload({ response: shippingCharges });
    }
    this.setState({ shippingCharges: shippingCharges });
  };

  initServiceCharges = async () => {
    const { masterDetailsObj } = this.state;
    const serviceChargesUrl = getServiceChargesUrl(masterDetailsObj);
    const serviceChargesResponse = await getCall(serviceChargesUrl, []);

    const { error } = serviceChargesResponse || {};
    if (error) {
      clearLocalStorageReload({ response: serviceChargesResponse });
    }
    const [serviceCharges] = serviceChargesResponse || {};
    this.setState({ serviceCharges: serviceCharges });
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        isMerchantGSTEnable: false,
        merchantInfo: {},
        AppTitle: "",
      });
    } else {
      this.setState({
        merchantInfo,
        AppTitle: merchantInfo.companyname,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initOrderViaWhatsApp = async () => {
    const { masterDetailsObj } = this.state;
    const orderViaWhatsappUrl = getOrderViaWhatsAppUrl(masterDetailsObj);
    const orderViaWhatsappResponse = await getCall(orderViaWhatsappUrl, []);
    if (orderViaWhatsappResponse.error) {
      clearLocalStorageReload({ response: orderViaWhatsappResponse });
      this.setState({ orderViaWhatsapp: {} });
    } else {
      if (orderViaWhatsappResponse.length > 0) {
        this.setState({
          orderViaWhatsapp: orderViaWhatsappResponse[0],
        });
      } else {
        this.setState({ orderViaWhatsapp: {} });
      }
    }
  };

  initUserDetails = async () => {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    const userDetailUrl = `users/${userDetails.id}`;
    const userDetailsResponse = await getCall(userDetailUrl, []);

    if (userDetailsResponse.error) {
      clearLocalStorageReload({ response: userDetailsResponse });
      this.loadErrorMessageAnimation(userDetailsResponse.error.message);
      if (userDetailsResponse.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      let shippingArray = [];
      try {
        shippingArray = userDetailsResponse.shippingaddress
          ? JSON.parse(userDetailsResponse.shippingaddress)
          : [];
      } catch (e) {
        shippingArray = [];
      }
      let selectedShippingAddressId = null;
      if (Array.isArray(shippingArray) && shippingArray.length) {
        const def = shippingArray.find((s) => s.isdefault) || shippingArray[0];
        selectedShippingAddressId = def ? def.id : null;
      } else if (shippingArray && shippingArray.id) {
        selectedShippingAddressId = shippingArray.id;
      }

      this.setState({
        userDetails: userDetailsResponse,
        selectedShippingAddressId,
      });
    }
  };

  initGroupWiseGSTINConfig = async () => {
    const { masterDetailsObj } = this.state;
    const groupWiseGSTINConfigUrl = getGroupWiseGSTConfigurationUrl(
      masterDetailsObj
    );
    const groupWiseGSTINConfig = await getCall(groupWiseGSTINConfigUrl, []);
    if (groupWiseGSTINConfig.error) {
      clearLocalStorageReload({ response: groupWiseGSTINConfig });
      this.loadErrorMessageAnimation(groupWiseGSTINConfig.error.message);
    } else {
      if (
        groupWiseGSTINConfig &&
        groupWiseGSTINConfig.length > 0 &&
        groupWiseGSTINConfig[0].status === 1
      ) {
        this.setState({
          groupWiseGSTINConfig: JSON.parse(groupWiseGSTINConfig[0].text),
        });
      }
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      this.setState({ currentCatelogueType: settings });
    }
  };

  initPincodeDelivery = async () => {
    const { masterDetailsObj } = this.state;
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      return;
    }
    const pincodeDelivery = await getCall(
      getPincodeDeliveryUrl(masterDetailsObj),
      []
    );
    if (pincodeDelivery.error) {
      clearLocalStorageReload({ response: pincodeDelivery });
      this.loadErrorMessageAnimation(pincodeDelivery.error.message);
    } else {
      if (pincodeDelivery.length > 0) {
        const status = pincodeDelivery[0].status;
        this.setState({ isPincodeDeliveryEnable: status === 1 ? true : false });
      }
    }
  };

  onChangeOfOrderNotes = (event) => {
    this.setState({ orderNotes: event.target.value });
  };

  makePaytmPayment = () => {
    this.loadCheckoutScript();
  };

  initiateSadadPayment = () => {
    this.getChecksumSadadPayment();
  };

  // onClickOfPlaceOrder = () => {
  //   const { currentCatelogueType, userDetails } = this.state;
  //   const { billingaddress, shippingaddress } = userDetails;
  //   // const billingAddress = JSON.parse(billingaddress)
  //   //   ? JSON.parse(billingaddress)
  //   //   : null;
  //   // const shippingAddress = JSON.parse(shippingaddress)
  //   //   ? JSON.parse(shippingaddress)
  //   //   : null;

  //   let parsedShipping = [];
  //   let parsedBilling = [];

  //   try {
  //     parsedShipping = userDetails.shippingaddress
  //       ? JSON.parse(userDetails.shippingaddress)
  //       : [];
  //   } catch (e) {
  //     parsedShipping = [];
  //   }
  //   try {
  //     parsedBilling = userDetails.billingaddress
  //       ? JSON.parse(userDetails.billingaddress)
  //       : [];
  //   } catch (e) {
  //     parsedBilling = [];
  //   }

  //   const selectedShipping =
  //     (Array.isArray(parsedShipping) &&
  //       parsedShipping.find(
  //         (s) => s.id === this.state.selectedShippingAddressId
  //       )) ||
  //     (Array.isArray(parsedShipping) &&
  //       parsedShipping.find((s) => s.isdefault)) ||
  //     (Array.isArray(parsedShipping) && parsedShipping[0]) ||
  //     parsedShipping;

  //   const selectedBilling =
  //     (Array.isArray(parsedBilling) &&
  //       parsedBilling.find((b) => b.isdefault)) ||
  //     (Array.isArray(parsedBilling) && parsedBilling[0]) ||
  //     parsedBilling;

  //   const { groupWiseGSTINConfig } = this.state;
  //   let found = false;
  //   if (
  //     userDetails &&
  //     userDetails.groupId !== null &&
  //     userDetails.groupId !== undefined
  //   ) {
  //     const temp = groupWiseGSTINConfig.map((groupId) => {
  //       if (userDetails.groupId === groupId) {
  //         found = true;
  //       }
  //       return groupId;
  //     });

  //     // if (
  //     //   found &&
  //     //   currentCatelogueType &&
  //     //   currentCatelogueType.registerallow === "Catalogue_FMCG"
  //     // ) {
  //     //   if (
  //     //     billingAddress.companyname === undefined ||
  //     //     billingAddress.companyname === "" ||
  //     //     billingAddress.companyname.trim().length === 0
  //     //   ) {
  //     //     this.loadErrorMessageAnimation(
  //     //       getValueFromLanguageObject(
  //     //         "str_company_name is_required_in_billing_address"
  //     //       )
  //     //         ? getValueFromLanguageObject(
  //     //             "str_company_name is_required_in_billing_address"
  //     //           )
  //     //         : "Company Name is required in billing address, Please add!"
  //     //     );
  //     //     return;
  //     //   }
  //     //   if (
  //     //     billingAddress.gstin === undefined ||
  //     //     billingAddress.gstin === "" ||
  //     //     billingAddress.gstin.trim().length === 0
  //     //   ) {
  //     //     this.loadErrorMessageAnimation(
  //     //       getValueFromLanguageObject(
  //     //         "str_gst_number is_required_in_billing_address"
  //     //       )
  //     //         ? getValueFromLanguageObject(
  //     //             "str_gst_number is_required_in_billing_address"
  //     //           )
  //     //         : "GST Number is required in billing address, Please add!"
  //     //     );
  //     //     return;
  //     //   }
  //     //   if (
  //     //     shippingAddress.companyname === undefined ||
  //     //     shippingAddress.companyname === "" ||
  //     //     shippingAddress.companyname.trim().length === 0
  //     //   ) {
  //     //     this.loadErrorMessageAnimation(
  //     //       getValueFromLanguageObject(
  //     //         "str_company_name_is_required_in_shipping_address"
  //     //       )
  //     //         ? getValueFromLanguageObject(
  //     //             "str_company_name_is_required_in_shipping_address"
  //     //           )
  //     //         : "Company Name is required in shipping address, Please add!"
  //     //     );
  //     //     return;
  //     //   }
  //     //   if (
  //     //     shippingAddress.gstin === undefined ||
  //     //     shippingAddress.gstin === "" ||
  //     //     shippingAddress.gstin.trim().length === 0
  //     //   ) {
  //     //     this.loadErrorMessageAnimation(
  //     //       getValueFromLanguageObject(
  //     //         "str_gst_number_is_required_in_shipping_address"
  //     //       )
  //     //         ? getValueFromLanguageObject(
  //     //             "str_gst_number_is_required_in_shipping_address"
  //     //           )
  //     //         : "GST Number is required in shipping address, Please add!"
  //     //     );
  //     //     return;
  //     //   }
  //     // }
  //   }
  //   this.paymnetDetailStatus();
  // };

  onClickOfPlaceOrder = () => {
    this.setState({ showConfirmOrderDialog: true });
  };

  handleConfirmPlaceOrder = async () => {
    this.setState({ showConfirmOrderDialog: false, isLoading: true });
    try {
      const response = await this.placeAnOrder();
      this.setState({ isLoading: false });
      if (
        response
      ) {
        const responseCode =
          (response.detail && response.detail.responseMessageCode) ||
          response.responseMessageCode ||
          response.responseStatus;
        if (responseCode === "INSUFFICIENT_REWARD_POINTS" || response.responseStatus >= 400) {
          const errMsg =
            (response.detail && response.detail.responseData && response.detail.responseData.message) ||
            (response.detail && response.detail.responseMessage) ||
            (response.responseData && response.responseData.message) ||
            response.responseMessage ||
            (response.error && response.error.message) ||
            "Insufficient reward points.";
          this.loadErrorMessageAnimation(errMsg);
          // Error modal will show, confirm dialog already closed
          return;
        }
      }
      if (response && response.id) {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("str_your_order_placed_successfully") ||
            "Your order placed successfully"
        );
        await this.fetchHeaderCounters(); // <-- add this line
        setTimeout(() => {
          this.props.history.push(`/orderdetails/${response.id}`);
        }, 1000);
      }
    } catch (error) {
      this.setState({ isLoading: false });
      this.loadErrorMessageAnimation(
        "Order could not be placed. Please try again."
      );
    }
  };

  onClickOfOrderViaWhatsApp = () => {
    const { userDetails, cartList, AppTitle, orderViaWhatsapp } = this.state;
    const { symbol, isInquiry } = this.props;

    let CustomerDetails = `${userDetails.username},\n${userDetails.cellnumber},`;

    if (!isInquiry) {
      const { billingaddress, shippingaddress } = userDetails;
      const billingaddressObj = billingaddress
        ? JSON.parse(billingaddress)
        : null;
      const shippingaddressObj = shippingaddress
        ? JSON.parse(shippingaddress)
        : null;

      var productList = "";
      const allOrderDetails = this.getAllOrderDetails();
      if (allOrderDetails && allOrderDetails.length > 0) {
        allOrderDetails.forEach((d) => {
          productList = productList.concat(
            ` ${d.products && d.products.name} - Qty : ${d.quantity}\n `
          );
        });
      }
      const subTotal = this.getSubTotalFromTotalandServiceCharges();
      let TotalAmount = this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        this.getShippingCharges(subTotal)
      );

      let billingAddressText = "";
      let shippingAddressText = "";

      if (billingaddressObj.name) {
        billingAddressText = billingAddressText.concat(
          `\nname : ${billingaddressObj.name}\n`
        );
      }

      if (billingaddressObj.mobile) {
        billingAddressText = billingAddressText.concat(
          `mobile : ${billingaddressObj.mobile}\n`
        );
      }

      if (billingaddressObj.email) {
        billingAddressText = billingAddressText.concat(
          ` ${
            getValueFromLanguageObject("str_email_address")
              ? getValueFromLanguageObject("str_email_address")
              : "Email Address"
          } : ${billingaddressObj.email}\n`
        );
      }

      if (billingaddressObj.companyname) {
        billingAddressText = billingAddressText.concat(
          `companyname : ${billingaddressObj.companyname}\n`
        );
      }

      if (billingaddressObj.gstin) {
        billingAddressText = billingAddressText.concat(
          ` ${
            getValueFromLanguageObject("str_gstin")
              ? getValueFromLanguageObject("str_gstin")
              : "GSTIN"
          } : ${billingaddressObj.gstin}\n`
        );
      }

      if (billingaddressObj.address1) {
        billingAddressText = billingAddressText.concat(
          `address1 : ${billingaddressObj.address1}\n`
        );
      }

      if (billingaddressObj.address2) {
        billingAddressText = billingAddressText.concat(
          `address2 : ${billingaddressObj.address2}\n`
        );
      }

      if (billingaddressObj.zonenumber) {
        billingAddressText = billingAddressText.concat(
          `zonenumber : ${billingaddressObj.zonenumber}\n`
        );
      }

      if (billingaddressObj.streetnumber) {
        billingAddressText = billingAddressText.concat(
          `streetnumber : ${billingaddressObj.streetnumber}\n`
        );
      }

      if (billingaddressObj.buildingnumber) {
        billingAddressText = billingAddressText.concat(
          `buildingnumber : ${billingaddressObj.buildingnumber}\n`
        );
      }

      if (billingaddressObj.unitnumber) {
        billingAddressText = billingAddressText.concat(
          `unitnumber : ${billingaddressObj.unitnumber}\n`
        );
      }

      if (billingaddressObj.landmark) {
        billingAddressText = billingAddressText.concat(
          `landmark : ${billingaddressObj.landmark}\n`
        );
      }

      if (billingaddressObj.cityname) {
        billingAddressText = billingAddressText.concat(
          `city : ${billingaddressObj.cityname}\n`
        );
      }
      if (billingaddressObj.statename) {
        billingAddressText = billingAddressText.concat(
          `state : ${billingaddressObj.statename}\n`
        );
      }
      if (billingaddressObj.countryname) {
        billingAddressText = billingAddressText.concat(
          `country : ${billingaddressObj.countryname}\n`
        );
      }

      if (billingaddressObj.zipcode) {
        billingAddressText = billingAddressText.concat(
          `zipcode : ${billingaddressObj.zipcode}`
        );
      }

      if (shippingaddressObj.name) {
        shippingAddressText = shippingAddressText.concat(
          `\nname : ${shippingaddressObj.name}\n`
        );
      }

      if (shippingaddressObj.mobile) {
        shippingAddressText = shippingAddressText.concat(
          `mobile : ${shippingaddressObj.mobile}\n`
        );
      }

      if (shippingaddressObj.email) {
        shippingAddressText = shippingAddressText.concat(
          ` ${
            getValueFromLanguageObject("str_email_address")
              ? getValueFromLanguageObject("str_email_address")
              : "Email Address"
          } : ${shippingaddressObj.email}\n`
        );
      }

      if (shippingaddressObj.companyname) {
        shippingAddressText = shippingAddressText.concat(
          `companyname : ${shippingaddressObj.companyname}\n`
        );
      }

      if (shippingaddressObj.gstin) {
        shippingAddressText = shippingAddressText.concat(
          ` ${
            getValueFromLanguageObject("str_gstin")
              ? getValueFromLanguageObject("str_gstin")
              : "GSTIN"
          } : ${shippingaddressObj.gstin}\n`
        );
      }

      if (shippingaddressObj.address1) {
        shippingAddressText = shippingAddressText.concat(
          `address1 : ${shippingaddressObj.address1}\n`
        );
      }

      if (shippingaddressObj.address2) {
        shippingAddressText = shippingAddressText.concat(
          `address2 : ${shippingaddressObj.address2}\n`
        );
      }

      if (shippingaddressObj.zonenumber) {
        shippingAddressText = shippingAddressText.concat(
          `zonenumber : ${shippingaddressObj.zonenumber}\n`
        );
      }

      if (shippingaddressObj.streetnumber) {
        shippingAddressText = shippingAddressText.concat(
          `streetnumber : ${shippingaddressObj.streetnumber}\n`
        );
      }

      if (shippingaddressObj.buildingnumber) {
        shippingAddressText = shippingAddressText.concat(
          `buildingnumber : ${shippingaddressObj.buildingnumber}\n`
        );
      }

      if (shippingaddressObj.unitnumber) {
        shippingAddressText = shippingAddressText.concat(
          `unitnumber : ${shippingaddressObj.unitnumber}\n`
        );
      }

      if (shippingaddressObj.landmark) {
        shippingAddressText = shippingAddressText.concat(
          `landmark : ${shippingaddressObj.landmark}\n`
        );
      }

      if (shippingaddressObj.cityname) {
        shippingAddressText = shippingAddressText.concat(
          `city : ${shippingaddressObj.cityname}\n`
        );
      }
      if (shippingaddressObj.statename) {
        shippingAddressText = shippingAddressText.concat(
          `state : ${shippingaddressObj.statename}\n`
        );
      }
      if (shippingaddressObj.countryname) {
        shippingAddressText = shippingAddressText.concat(
          `country : ${shippingaddressObj.countryname}\n`
        );
      }

      if (shippingaddressObj.zipcode) {
        shippingAddressText = shippingAddressText.concat(
          `zipcode : ${shippingaddressObj.zipcode}`
        );
      }

      let orderNotesText = "";
      if (this.state.orderNotes) {
        orderNotesText = `Order Notes : ${this.state.orderNotes}`;
      }

      let text = `New order - ${AppTitle}\nOrderId : ${this.getOrderId(
        cartList
      )}\nItems : ${productList} \nAmount Payable : ${TotalAmount}\n\nCustomer Details : \n${CustomerDetails} \nBilling Address : ${billingAddressText} \n\nShipping Address : ${shippingAddressText} \n\n${orderNotesText}`;
      const mobileNumber = JSON.parse(orderViaWhatsapp.text).cellnumber;
      const countryCode = JSON.parse(orderViaWhatsapp.text).countryCode;
      var whatsAppLink = `https://api.whatsapp.com/send?phone=${countryCode}${mobileNumber}&text=${encodeURI(
        text
      )}`;
      window.open(whatsAppLink);
      return;
    } else {
      productList = "";
      const allOrderDetails = this.getAllOrderDetails();
      if (allOrderDetails && allOrderDetails.length > 0) {
        allOrderDetails.forEach((d) => {
          productList = productList.concat(
            ` ${d.products && d.products.name} - Qty : ${d.quantity}\n `
          );
        });
      }

      let text = `New Inquiry - ${AppTitle}\nInquiryId : ${this.getOrderId(
        cartList
      )}\nItems : ${productList} \nCustomer Details : \n${CustomerDetails}`;

      const mobileNumber = JSON.parse(orderViaWhatsapp.text).cellnumber;
      const countryCode = JSON.parse(orderViaWhatsapp.text).countryCode;
      whatsAppLink = `https://api.whatsapp.com/send?phone=${countryCode}${mobileNumber}&text=${encodeURI(
        text
      )}`;
      window.open(whatsAppLink);
      return;
    }
  };

  paymnetDetailStatus = async () => {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails === undefined) {
      return;
    }
    const { paymentMethod, paymentDetails } = this.state;

    if (
      paymentDetails &&
      paymentDetails.length > 0 &&
      paymentDetails[0].status === 0
    ) {
      this.setState({ isLoading: true });
      this.placeAnOrder().then(() => {
        this.setState({ isLoading: false });
      });
    } else {
      if (paymentMethod === "Cash On Delivery") {
        this.setState({ isLoading: true });
        this.placeAnOrder().then((response) => {
          console.log("Order placed successfully", response);
          this.setState({ isLoading: false }, () => {
            setTimeout(() => {
              if (response && response.id) {
                this.props.history.push(`/orderdetails/${response.id}`);
              } else {
                // Show error or handle gracefully
                this.loadErrorMessageAnimation(
                  "Order could not be placed. Please try again."
                );
              }
            }, 1000);
            //   this.initUpdatePaymentStatusCOD();
          });
        });
      }
      if (paymentMethod === "RazorPay") {
        this.setState({ isLoading: true }, () => {
          this.placeAnOrder().then(() => {
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.initRazorPayPayment();
            }, 500);
          });
        });
      } else if (paymentMethod === "Paytm") {
        this.setState({ isLoading: true }, () => {
          this.placeAnOrder().then(() => {
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.generateChecksumPaytmPayment();
            }, 500);
          });
        });
      } else if (paymentMethod === "PayU") {
        this.setState({ isLoading: true }, () => {
          this.placeAnOrder().then(() => {
            this.setState({ isLoading: false });
            setTimeout(() => {
              this.initPayUMoneyPayment();
            }, 750);
          });
        });
      } else if (paymentMethod === "Paypal") {
        this.setState({ isLoading: true }, () => {
          this.placeAnOrder().then(() => {
            this.setState({ isLoading: false, isHidePlaceOrderButton: false });
            setTimeout(() => {
              this.initPaypalPayment();
            }, 750);
          });
        });
      } else if (paymentMethod === "GooglePay") {
        this.setState({ isLoading: true }, () => {
          this.placeAnOrder().then(() => {
            this.setState({ isLoading: false, isHidePlaceOrderButton: false });
            this.initGooglePayPayment();
          });
        });
      } else if (paymentMethod === "Sadad") {
        this.setState({ isLoading: true }, () => {
          this.placeAnOrder().then(() => {
            this.setState({ isLoading: false });
            this.payWithSadad();
          });
        });
      }
    }
  };

  renderLogoDynamic = async () => {
    const { masterDetailsObj } = this.state;
    let path = `${process.env.SERVER_URL}`;
    if (masterDetailsObj && masterDetailsObj.id) {
      const logoUrl = getMerchantInformationUrl(masterDetailsObj);
      const logoResponse = await getCall(logoUrl, []);
      if (logoResponse.error) {
        clearLocalStorageReload({ response: logoResponse });
        return;
      } else {
        path = `${path}/api/containers/profilepic-${masterDetailsObj.codename}/download/${logoResponse.profilepic}`;
        return path;
      }
    }
  };

  initUpdatePaymentStatusCOD = async () => {
    const { cartList, paymentResponse, paymentMethod } = this.state;
    const orderId = this.getOrderId(cartList);
    const updatePaymentTransactionIdUrl = `orders/${orderId}`;
    let transactionNumber = "";

    // const updatePaymentTransactionIdObj = {
    //   paymentDetail: {
    //     transaction_no: transactionNumber,
    //     other_transaction_details: paymentResponse,
    //     pay_via: paymentMethod,
    //   },
    //   paymentstatus: 1, // Pending
    //   order_id: orderId,
    // };
    // const updatePaymentTransactionId = await patchCall(
    //   updatePaymentTransactionIdUrl,
    //   updatePaymentTransactionIdObj
    // );
    // if (updatePaymentTransactionId.error) {
    //   clearLocalStorageReload({ response: updatePaymentTransactionId });
    //   this.loadErrorMessageAnimation(updatePaymentTransactionId.error.message);
    //   if (updatePaymentTransactionId.error.statusCode === 401) {
    //     removeUserDetailAndOtherDetails();
    //     navigateTo(this.props, `/login`);
    //     return;
    //   }
    // } else {
    //   setTimeout(() => {
    //     this.props.history.push(`/orderdetails/${orderId}`);
    //   }, 1000);
    // }
  };

  // RazorPay
  initRazorPayPayment = async () => {
    const {
      isMerchantGSTEnable,
      cartList,
      AppTitle,
      currentCatelogueType,
      paymentDetails,
      masterDetailsObj,
    } = this.state;
    const userDetails = loadUserDetailsFromLocalStorage();
    const logo = this.renderLogoDynamic(masterDetailsObj);
    var paymentAmount = 0;
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow !== "Catalogue_Jewellary"
    ) {
      paymentAmount = this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        this.getShippingCharges(subTotal)
      );
    } else if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      paymentAmount = this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        this.getShippingCharges(subTotal)
      );
    } else {
      paymentAmount = subTotal + this.getShippingCharges(subTotal);
    }

    if (paymentDetails && paymentDetails.length > 0 && paymentDetails[0]) {
      const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
        (paymentMethods) => {
          return paymentMethods.name === "RazorPay";
        }
      );
      const mId = paytmPaymentMethodDetails[0].config.key_id;
      const paymentResponse = await payment({
        key: mId,
        clientName: AppTitle,
        clientLogo: logo,
        amount: paymentAmount.toFixed(2),
        mobile: userDetails.cellnumber,
        email: userDetails.email,
        name: userDetails.username,
        currency: "INR",
        orderId: this.getOrderId(cartList),
      });
      if (paymentResponse.error) {
        this.loadErrorMessageAnimation(paymentResponse.error.message);
      } else {
        // TODO Add to language object
        this.loadSuccessMessageAnimation("Payment is successfully completed");
      }
      this.setState({ paymentResponse }, () => {
        this.updatePaymentStatusRazorPay();
      });
    }
  };

  // RazorPay
  updatePaymentStatusRazorPay = async () => {
    const { cartList, paymentResponse, paymentMethod } = this.state;
    const orderId = this.getOrderId(cartList);
    const updatePaymentTransactionIdUrl = `orders/${orderId}`;
    let transactionNumber = "";
    if (paymentMethod === "RazorPay") {
      transactionNumber = paymentResponse.razorpay_payment_id;
    }
    const {
      error,
      razorpay_payment_id,
      transaction_status: transactionStatus,
    } = paymentResponse || {};
    const { transaction_status } = error || {};
    const paymentStatus = razorpay_payment_id
      ? transactionStatus
      : transaction_status;

    const updatePaymentTransactionIdObj = {
      paymentDetail: {
        transaction_no: transactionNumber,
        other_transaction_details: paymentResponse,
        pay_via: paymentMethod,
      },
      paymentstatus: paymentStatus,
      order_id: orderId,
    };

    this.setState({ isLoading: true });
    const updatePaymentTransactionId = await patchCall(
      updatePaymentTransactionIdUrl,
      updatePaymentTransactionIdObj
    );
    this.setState({ isLoading: false });

    if (updatePaymentTransactionId.error) {
      clearLocalStorageReload({ response: updatePaymentTransactionId });
      this.loadErrorMessageAnimation(updatePaymentTransactionId.error.message);
      if (updatePaymentTransactionId.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      setTimeout(() => {
        this.props.history.push(`/orderdetails/${orderId}`);
      }, 1000);
    }
  };

  // PayTM
  generateChecksumPaytmPayment = async () => {
    const { cartList, paymentDetails } = this.state;
    const orderId = this.getOrderId(cartList);
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    const totalAmount = this.getGrandTotal(
      subTotal,
      this.getCGSTFromTotal(subTotal),
      this.getSGSTFromTotal(subTotal),
      this.getIGSTFromTotal(subTotal),
      this.getShippingCharges(subTotal)
    );

    const initPaytmPaymentUrl = "orders/genratepaytmchecksum";
    let initPaytmPaymentObj = {
      orderId: orderId,
      amount: totalAmount,
      callbackUrl: window.location.href,
    };
    this.setState({ isPlaceOrderButtonDisable: true }, async () => {
      this.setState({ isLoading: true });
      const initPaytmPaymentResponse = await postCall(
        initPaytmPaymentUrl,
        initPaytmPaymentObj
      );
      this.setState({ isLoading: false, isPlaceOrderButtonDisable: false });
      if (initPaytmPaymentResponse.error) {
        this.loadErrorMessageAnimation(initPaytmPaymentResponse.error.message);
        clearLocalStorageReload({ response: initPaytmPaymentResponse });
      }
      if (
        initPaytmPaymentResponse &&
        initPaytmPaymentResponse.body &&
        initPaytmPaymentResponse.body.txnToken
      ) {
        this.setState({ isPlaceOrderButtonDisable: false });
        if (paymentDetails && paymentDetails.length > 0 && paymentDetails[0]) {
          const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
            (paymentMethods) => {
              return paymentMethods.name === "Paytm";
            }
          );
          const mId = paytmPaymentMethodDetails[0].config.PaytmMerchantID;
          const logo = this.renderLogoDynamic();
          let obj = {
            mid: "" + mId,
            orderId: orderId,
            amount: this.getGrandTotal(
              subTotal,
              this.getCGSTFromTotal(subTotal),
              this.getSGSTFromTotal(subTotal),
              this.getIGSTFromTotal(subTotal),
              this.getShippingCharges(subTotal)
            ),
            token: initPaytmPaymentResponse.body.txnToken,
            merchantName:
              paytmPaymentMethodDetails[0].config.paymentMerchantName,
            logo: logo,
            callbackUrl: window.location.href,
          };
          const paytmC = this.appendHandler(paytmConfigure(obj));
          this.setState({ paytmConfig: paytmC }, () => {
            this.makePaytmPayment();
          });
        }
      } else if (
        initPaytmPaymentResponse &&
        initPaytmPaymentResponse.body &&
        initPaytmPaymentResponse.body.resultInfo
      ) {
        this.loadErrorMessageAnimation(
          initPaytmPaymentResponse.body.resultInfo.resultMsg
        );
      }
    });
  };

  // Paypal - 1
  initPaypalPayment = () => {
    const { cartList, paymentDetails } = this.state;

    const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
      (paymentMethods) => {
        return paymentMethods.name === "Paypal";
      }
    );
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    let obj = {
      env: "production", // set this to prduction
      currency: "USD", // Paypal is not allowing user to pay in india
      total: this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        this.getShippingCharges(subTotal)
      ),
      client: {
        sandbox: paytmPaymentMethodDetails[0].config.PaypalClientToken,
        production: paytmPaymentMethodDetails[0].config.PaypalClientToken,
      },
    };
    this.setState({ payPalConfig: obj }, () => {});
  };

  // Paypal - 2
  onSuccessOfPaypalPayment = (payment) => {
    // Congratulation, it came here means everything's fine!
    console.log("The payment was succeeded!", payment);
    if (payment.paid) {
      // TODO Add to language object
      this.loadSuccessMessageAnimation("Payment is successfully completed");
      this.setState({ paymentResponse: payment }, () => {
        this.updatePaymentStatusPayPal(2);
      });
    } else {
      // TODO Add to language object
      this.loadErrorMessageAnimation("Payment failed");
      this.setState({ paymentResponse: payment }, () => {
        this.updatePaymentStatusPayPal(3);
      });
    }
    // You can bind the "payment" object's value to your state or props or whatever here, please see below for sample returned data
  };

  // Paypal - 3
  onCancelOfPaypalPayment = (data) => {
    // User pressed "cancel" or close Paypal's popup!
    console.log("The payment was cancelled!", data);
    // You can bind the "data" object's value to your state or props or whatever here, please see below for sample returned data
    // TODO Add to language object
    this.loadErrorMessageAnimation("Payment failed");
    this.setState({ paymentResponse: data }, () => {
      this.updatePaymentStatusPayPal(3);
    });
  };

  // Paypal - 4
  onErrorOfPaypalPayment = (err) => {
    // The main Paypal's script cannot be loaded or somethings block the loading of that script!
    console.log("Error!", err);
    // Because the Paypal's main script is loaded asynchronously from "https://www.paypalobjects.com/api/checkout.js"
    // => sometimes it may take about 0.5 second for everything to get set, or for the button to appear
    // TODO Add to language object
    this.loadErrorMessageAnimation("Payment failed");
    this.setState({ paymentResponse: err }, () => {
      this.updatePaymentStatusPayPal(3);
    });
  };

  // Paypal - 5
  updatePaymentStatusPayPal = async (paymentStatus) => {
    const { cartList, paymentResponse, paymentMethod } = this.state;
    const orderId = this.getOrderId(cartList);
    const updatePaymentTransactionIdUrl = `orders/${orderId}`;
    const { paymentID, payerID } = paymentResponse;

    const updatePaymentTransactionIdObj = {
      paymentDetail: {
        transaction_no: paymentID,
        other_transaction_details: paymentResponse,
        pay_via: paymentMethod,
      },
      paymentstatus: paymentStatus,
      orderId: payerID,
    };
    const updatePaymentTransactionId = await patchCall(
      updatePaymentTransactionIdUrl,
      updatePaymentTransactionIdObj
    );
    if (updatePaymentTransactionId.error) {
      clearLocalStorageReload({ response: updatePaymentTransactionId });
      this.loadErrorMessageAnimation(updatePaymentTransactionId.error.message);
      if (updatePaymentTransactionId.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      setTimeout(() => {
        this.props.history.push(`/orderdetails/${orderId}`);
      }, 1000);
    }
  };

  // PayU Money - 1
  initPayUMoneyPayment = async () => {
    try {
      const { cartList, paymentDetails } = this.state;
      // Get User Details From Local Storage
      const userDetails = loadUserDetailsFromLocalStorage();
      const { billingaddress } = userDetails;
      const billingaddressObj = billingaddress
        ? JSON.parse(billingaddress)
        : {};
      const { name, email, cellnumber } = billingaddressObj;
      const orderId = this.getOrderId(cartList);

      // Get Selected Payment Details from payment details config
      const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
        (paymentMethods) => {
          return paymentMethods.name === "PayU";
        }
      );

      // Merchant Key
      const key = paytmPaymentMethodDetails[0].config.PayUMerchantKey;
      const subTotal = this.getSubTotalFromTotalandServiceCharges();
      // Total Amount
      const totalAmount = this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        this.getShippingCharges(subTotal)
      );

      // Product Details
      const productInfo = this.getProductIds(cartList);

      // Row Object for checkou script
      var rowObject = {
        key: key,
        txnid: orderId,
        amount: totalAmount,
        firstname: name,
        email,
        phone: cellnumber,
        productinfo: productInfo,
        surl: `/${process.env.PUBLIC_URL}/checkout`,
        furl: `/${process.env.PUBLIC_URL}/checkout`,
        hash: "",
      };

      const { txnid, amount, productinfo, firstname } = rowObject;

      // Generate Checksum Object
      let data = {
        txnId: txnid,
        email,
        amount,
        productinfo: productinfo,
        firstname: firstname,
      };

      this.setState({ isLoading: true });
      const payUMoneyHash = await postCall("orders/genratepayumoneyhash", data);
      this.setState({ isLoading: false });
      if (payUMoneyHash && payUMoneyHash.error) {
        clearLocalStorageReload({ response: payUMoneyHash });
        this.loadErrorMessageAnimation(payUMoneyHash.error.message);
        if (payUMoneyHash.error.statusCode === 401) {
          removeUserDetailAndOtherDetails();
          navigateTo(this.props, `/login`);
          return;
        }
        // Update Payment Status if any error and redirect user to order summary page
        setTimeout(() => {
          this.setState({ isLoading: true });
          this.updatePaymentStatusPayUMoney(3).then(() => {
            this.setState({ isLoading: false });
          });
        }, 750);
      } else {
        rowObject.hash = payUMoneyHash.hash;
        this.setState({ payUMoneyConfig: rowObject }, () => {
          this.loadPayUMoneyBoltCheckout();
        });
      }
    } catch (error) {
      // Update Payment Status if any error and redirect user to order summary page
      this.setState({ isLoading: true });
      this.updatePaymentStatusPayUMoney(3).then(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  // PayU Money - 2
  loadPayUMoneyBoltCheckout = () => {
    const { payUMoneyConfig } = this.state;

    window.bolt.launch(payUMoneyConfig, {
      responseHandler: (response) => {
        // console.log("response");
        // console.log(response);
        // your payment response Code goes here
        if (response.response.status === "success") {
          this.setState(
            {
              paymentResponse: response,
              isLoading: true,
            },
            () => {
              this.updatePaymentStatusPayUMoney(2).then(() => {
                this.setState({ isLoading: false });
              });
            }
          );
        } else if (response.response.txnStatus === "CANCEL") {
          this.loadErrorMessageAnimation(response.response.txnMessage);
          setTimeout(() => {
            this.setState({ isLoading: true });
            this.updatePaymentStatusPayUMoney(3).then(() => {
              this.setState({ isLoading: false });
            });
          }, 750);
        }
      },
      catchException: (error) => {
        console.log("error");
        console.log(error);
        this.setState({ isLoading: true });
        this.updatePaymentStatusPayUMoney(3).then(() => {
          this.setState({ isLoading: false });
        });
        // the code you use to handle the integration errors goes here
        // Make any UI changes to convey the error to the user
      },
    });
  };

  // PayU Money - 3
  updatePaymentStatusPayUMoney = async (paymentStatus) => {
    const { cartList, paymentResponse, paymentMethod } = this.state;
    const orderId = this.getOrderId(cartList);
    const updatePaymentTransactionIdUrl = `orders/${orderId}`;

    const { response } = paymentResponse || {};
    const { encryptedPaymentId, txnid } = response || {};

    const updatePaymentTransactionIdObj = {
      paymentDetail: {
        transaction_no: encryptedPaymentId,
        other_transaction_details: response,
        pay_via: paymentMethod,
      },
      paymentstatus: paymentStatus,
      order_id: txnid,
    };

    const updatePaymentTransactionId = await patchCall(
      updatePaymentTransactionIdUrl,
      updatePaymentTransactionIdObj
    );

    if (updatePaymentTransactionId.error) {
      clearLocalStorageReload({ response: updatePaymentTransactionId });
      this.loadErrorMessageAnimation(updatePaymentTransactionId.error.message);
      if (updatePaymentTransactionId.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      // TODO Add to language object
      this.loadSuccessMessageAnimation("Payment is successfully completed");
      setTimeout(() => {
        this.props.history.push(`/orderdetails/${orderId}`);
      }, 1000);
    }
  };

  // Google Pay - 1
  initGooglePayPayment = () => {
    const { cartList, paymentDetails } = this.state;

    const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
      (paymentMethods) => {
        return paymentMethods.name === "GooglePay";
      }
    );
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    let obj = {
      merchantId: paytmPaymentMethodDetails[0].config.MERCHANT_ID,
      merchantName: paytmPaymentMethodDetails[0].config.MERCHANT_NAME,
      amount: this.getGrandTotal(
        subTotal,
        this.getCGSTFromTotal(subTotal),
        this.getSGSTFromTotal(subTotal),
        this.getIGSTFromTotal(subTotal),
        this.getShippingCharges(subTotal)
      ),
      gateway: "example",
    };

    const gPayConfig = GooglePayConfigure(obj);
    this.setState({ googlePayConfig: gPayConfig });
  };

  // Google Pay - 2
  makeGooglePayPayment = (payment) => {
    // TODO Add to language object
    this.loadSuccessMessageAnimation("Payment is successfully completed");
    this.setState({ paymentResponse: payment }, () => {
      this.updatePaymentStatusGooglePay(2);
    });
  };

  // Google Pay - 3
  updatePaymentStatusGooglePay = async (paymentStatus) => {
    const { cartList, paymentResponse, paymentMethod } = this.state;
    const orderId = this.getOrderId(cartList);
    const updatePaymentTransactionIdUrl = `orders/${orderId}`;

    const { paymentMethodData } = paymentResponse || {};
    const { tokenizationData } = paymentMethodData || {};
    const { token } = tokenizationData || {};

    const updatePaymentTransactionIdObj = {
      paymentDetail: {
        transaction_no: "",
        other_transaction_details: paymentResponse,
        pay_via: paymentMethod,
      },
      paymentstatus: paymentStatus,
      orderId: orderId,
    };
    const updatePaymentTransactionId = await patchCall(
      updatePaymentTransactionIdUrl,
      updatePaymentTransactionIdObj
    );
    if (updatePaymentTransactionId.error) {
      clearLocalStorageReload({ response: updatePaymentTransactionId });
      this.loadErrorMessageAnimation(updatePaymentTransactionId.error.message);
      if (updatePaymentTransactionId.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    }
    setTimeout(() => {
      this.props.history.push(`/orderdetails/${orderId}`);
    }, 1000);
  };

  // Sadad
  payWithSadad = async () => {
    const { cartList, paymentDetails } = this.state;
    const {
      id: userId,
      email: userEmail,
      cellnumber: userCellnumber,
    } = loadUserDetailsFromLocalStorage();
    const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
      (paymentMethods) => {
        return paymentMethods.name === "Sadad";
      }
    );

    const merchantId = paytmPaymentMethodDetails[0].config.MERCHANT_ID;
    const secretKey = paytmPaymentMethodDetails[0].config.MERCHANT_KEY;
    const orderId = this.getOrderId(cartList);
    const totalProductItems = this.getTotalProductItems(cartList);
    const sadadPageLanguage = getCurrentLanguage();
    const currentUrl = window.location.href;
    const callbackPageUrl = currentUrl.substring(
      0,
      currentUrl.lastIndexOf("/")
    );
    const sadadCallbackUrl = process.env.SADAD_CALLBACK_URL;
    const sadadPaymentWebsite = process.env.SADAD_WEBSITE_URL;
    const transactionDate = getCurrentDate();
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    const totalAmount = this.getGrandTotal(
      subTotal,
      this.getCGSTFromTotal(subTotal),
      this.getSGSTFromTotal(subTotal),
      this.getIGSTFromTotal(subTotal),
      this.getShippingCharges(subTotal)
    );
    const productionDetails = [
      {
        order_id: orderId,
        itemname: "Product",
        amount: totalAmount.toFixed(2),
        quantity: totalProductItems.toString(),
        // type: "line_item",
      },
    ];
    const sadadCheckoutVersion = process.env.SADAD_CHECKOUT_VERSION;

    const checksumObj = sadadPaymentConfigure({
      merchantId,
      orderId,
      sadadPaymentWebsite,
      totalAmount: totalAmount.toFixed(2),
      userId,
      userEmail,
      userCellnumber,
      sadadPageLanguage,
      sadadCallbackUrl,
      transactionDate,
      productionDetails,
      sadadCheckoutVersion,
    });

    const sadadPaymentChecksumUrl = getSadadPaymentChecksumUrl();
    const checksumResponse = await customPostCall(
      sadadPaymentChecksumUrl,
      checksumObj,
      secretKey
    );
    this.setState({ sadadPaymentConfig: checksumObj }, () => {
      this.setState({ sadadPaymentChecksum: checksumResponse.checksum }, () => {
        this.setState({ isOpenPayWithSadad: true }, () => {
          const paymentForm = document.getElementById("paymentform");
          // console.log("paymentForm");
          // console.log(paymentForm);
          paymentForm.submit();
        });
      });
    });
  };

  initBillingShippingAddressConfig = async () => {
    const { masterDetailsObj } = this.state;
    const billingShippingAddressUrl = getAddressDetailUrl(masterDetailsObj);

    const billingShippingAddressResponse = await getCall(
      billingShippingAddressUrl,
      []
    );

    if (billingShippingAddressResponse.error) {
      clearLocalStorageReload({ response: billingShippingAddressResponse });
    } else {
      if (billingShippingAddressResponse.length > 0) {
        const billingShippingAddress = JSON.parse(
          billingShippingAddressResponse[0].text
        );
        this.setState({ billingShippingAddress });
      }
    }
  };

  getCGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.CGST) / 100;
  };

  getSGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.SGST) / 100;
  };

  getIGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.IGST) / 100;
  };

  getGrandTotal = (total, cgst, sgst, igst, shippingCharge) => {
    const { merchantInfo, currentCatelogueType } = this.state;
    var grandTotal = 0;
    if (merchantInfo.enablegst === 0) {
      grandTotal = total + shippingCharge;

      return grandTotal;
    }
    if (
      merchantInfo.enablegst === 1 &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      grandTotal = total + shippingCharge;

      return grandTotal;
    }
    if (merchantInfo.countryname === "India") {
      grandTotal = total + cgst + sgst + shippingCharge;
    } else {
      grandTotal = total + igst + shippingCharge;
    }

    return grandTotal;
  };

  getShippingCharges = (total) => {
    const { shippingCharges, isPincodeDeliveryEnable } = this.state;
    var charge = 0;
    if (isPincodeDeliveryEnable) {
      return this.getShippingPriceFromCart();
    }
    if (shippingCharges.length > 0) {
      for (let index = 0; index < shippingCharges.length; index++) {
        if (
          shippingCharges[index].id === 3 &&
          shippingCharges[index].status === 1
        ) {
          for (
            let jindex = 0;
            jindex < shippingCharges[index].options.length;
            jindex++
          ) {
            if (
              !shippingCharges[index].options[jindex].maxCondition &&
              shippingCharges[index].options[jindex].minValue <= total &&
              shippingCharges[index].options[jindex].maxValue >= total
            ) {
              charge = shippingCharges[index].options[jindex].charges;
              break;
            }
            if (
              shippingCharges[index].options[jindex].maxCondition &&
              shippingCharges[index].options[jindex].minValue <= total
            ) {
              charge = shippingCharges[index].options[jindex].charges;
              break;
            }
          }
        }
      }
    }
    return charge;
  };

  placeAnInquiry = async () => {
    const placeAninquiryUrl = "orders/placeOrder";
    var placeAnInquiryObj = {};
    const { cartList } = this.state;
    const user = loadUserDetailsFromLocalStorage();
    if (user === undefined) {
      removeUserDetailAndOtherDetails();
      navigateTo(this.props, `/login`);
      return;
    }
    const { id } = user;
    placeAnInquiryObj = {
      orderId: this.getOrderId(cartList),
      userId: id,
      inshoppingcart: 2,
    };
    const placeInquiry = await patchCall(placeAninquiryUrl, placeAnInquiryObj);
    if (placeInquiry.error) {
      clearLocalStorageReload({ response: placeInquiry });
      this.loadErrorMessageAnimation(placeInquiry.error.message);
      if (placeInquiry.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.loadSuccessMessageAnimation(
        getValueFromLanguageObject("str_your_inquiry_placed_successfully")
          ? getValueFromLanguageObject("str_your_inquiry_placed_successfully")
          : "Your inquiry placed successfully"
      );
      setTimeout(() => {
        this.props.history.push(`/orderdetails/${this.getOrderId(cartList)}`);
      }, 750);
    }
  };

  placeAnOrder = async () => {
    const { isInquiry } = this.props;
    const {
      isMerchantGSTEnable,
      merchantInfo,
      userDetails,
      serviceCharges,
    } = this.state;

    // Debug logging
    console.log("=== PLACE ORDER DEBUG ===");
    console.log("serviceCharges:", serviceCharges);
    console.log("serviceCharges type:", typeof serviceCharges);
    console.log(
      "serviceCharges.text:",
      serviceCharges ? serviceCharges.text : "undefined"
    );

    const shippingAddress = JSON.parse(userDetails.shippingaddress);
    const billingAddress = JSON.parse(userDetails.billingaddress);

    // Add null checks for serviceCharges
    let serviceChargeFirst = [];
    let additionalchargedetailsObj = {
      label: "",
      type: "isAmount",
      typevalue: 0,
      charges: this.getServiceChargesBasedOnTotalAmount(),
    };

    if (serviceCharges && serviceCharges.text) {
      try {
        serviceChargeFirst = JSON.parse(serviceCharges.text);
        const additionalchargedetailsArray = serviceChargeFirst;

        if (
          Array.isArray(additionalchargedetailsArray) &&
          additionalchargedetailsArray.length > 0
        ) {
          const [labelObj] = additionalchargedetailsArray.filter(
            (sc) => sc.key === "label"
          );
          const [isPercentageObj] = additionalchargedetailsArray.filter(
            (sc) => sc.key === "isPercentage"
          );
          const [percentageObj] = additionalchargedetailsArray.filter(
            (sc) => sc.key === "percentage"
          );
          const [amountObj] = additionalchargedetailsArray.filter(
            (sc) => sc.key === "amount"
          );

          additionalchargedetailsObj = {
            label: labelObj ? labelObj.value : "",
            type:
              isPercentageObj && isPercentageObj.value
                ? "isPercentage"
                : "isAmount",
            typevalue:
              isPercentageObj && isPercentageObj.value
                ? percentageObj
                  ? percentageObj.value
                  : 0
                : amountObj
                ? amountObj.value
                : 0,
            charges: this.getServiceChargesBasedOnTotalAmount(),
          };
        }
      } catch (error) {
        console.error("Error parsing serviceCharges.text:", error);
        // Use default values if parsing fails
      }
    }

    const user = loadUserDetailsFromLocalStorage();
    if (user === undefined) {
      removeUserDetailAndOtherDetails();
      navigateTo(this.props, `/login`);
      return;
    }

    const { id } = user;
    const { cartList, currentCatelogueType } = this.state;
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    const totalAmount = this.getGrandTotal(
      subTotal,
      this.getCGSTFromTotal(subTotal),
      this.getSGSTFromTotal(subTotal),
      this.getIGSTFromTotal(subTotal),
      this.getShippingCharges(subTotal)
    );
    const placeOrderUrl = "v2/orders/place-order";
    var placeOrderObj = {};

    if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow !== "Catalogue_Jewellary"
    ) {
      placeOrderObj = {
        orderId: this.getOrderId(cartList),
        totalamount: totalAmount,
        userId: id,
        inshoppingcart: 0,
        description: this.state.orderNotes,
        shippingaddress: shippingAddress,
        billingaddress: billingAddress,
        additionalcharge: this.getServiceChargesBasedOnTotalAmount(),
        additionalchargedetails: additionalchargedetailsObj,
        tax: {
          cgst: merchantInfo.CGST,
          sgst: merchantInfo.SGST,
          cgstPrice: this.getCGSTFromTotal(subTotal),
          sgstPrice: this.getSGSTFromTotal(subTotal),
        },
        baseprice: subTotal,
        shippingprice: this.getShippingCharges(subTotal),
      };
    } else if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      placeOrderObj = {
        orderId: this.getOrderId(cartList),
        totalamount: totalAmount,
        userId: id,
        inshoppingcart: 0,
        description: this.state.orderNotes,
        shippingaddress: shippingAddress,
        billingaddress: billingAddress,
        additionalcharge: this.getServiceChargesBasedOnTotalAmount(),
        additionalchargedetails: additionalchargedetailsObj,
        baseprice: subTotal,
        shippingprice: this.getShippingCharges(subTotal),
      };
    } else {
      placeOrderObj = {
        orderId: this.getOrderId(cartList),
        totalamount: totalAmount,
        userId: id,
        inshoppingcart: 0,
        description: this.state.orderNotes,
        shippingaddress: shippingAddress,
        billingaddress: billingAddress,
        additionalcharge: this.getServiceChargesBasedOnTotalAmount(),
        additionalchargedetails: additionalchargedetailsObj,
        shippingprice: this.getShippingCharges(subTotal),
      };
    }

    const placeOrder = await patchCall(placeOrderUrl, placeOrderObj);
    if (placeOrder.error) {
      clearLocalStorageReload({ response: placeOrder });
      this.loadErrorMessageAnimation(placeOrder.error.message);
      if (placeOrder.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      // Handle INSUFFICIENT_REWARD_POINTS or other error shapes returned at top-level
      const placeOrderCode =
        (placeOrder.detail && placeOrder.detail.responseMessageCode) ||
        placeOrder.responseMessageCode ||
        placeOrder.responseStatus;
      if (placeOrderCode === "INSUFFICIENT_REWARD_POINTS" || (placeOrder.responseStatus && placeOrder.responseStatus >= 400)) {
        const errMsg =
          (placeOrder.detail && placeOrder.detail.responseData && placeOrder.detail.responseData.message) ||
          (placeOrder.detail && placeOrder.detail.responseMessage) ||
          (placeOrder.responseData && placeOrder.responseData.message) ||
          placeOrder.responseMessage ||
          (placeOrder.error && placeOrder.error.message) ||
          "Insufficient reward points.";
        this.loadErrorMessageAnimation(errMsg);
        return; // Prevent redirect or further actions
      }
      if (isInquiry) {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("str_your_inquiry_placed_successfully")
            ? getValueFromLanguageObject("str_your_inquiry_placed_successfully")
            : "Your inquiry placed successfully"
        );
      } else {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("str_your_order_placed_successfully")
            ? getValueFromLanguageObject("str_your_order_placed_successfully")
            : "Your order placed successfully"
        );
      }
      return placeOrder;
    }
  };

  getTotalofCart(cartList) {
    let total = 0;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      cartList.forEach((cartItem) => {
        if (
          cartItem &&
          cartItem.orderdetails &&
          Array.isArray(cartItem.orderdetails)
        ) {
          for (let i = 0; i < cartItem.orderdetails.length; i++) {
            const orderDetail = cartItem.orderdetails[i];
            if (orderDetail && orderDetail.amount && orderDetail.quantity) {
              total = total + orderDetail.amount * orderDetail.quantity;
            }
          }
        }
        // Also check for orderdetail (singular) for backward compatibility
        if (
          cartItem &&
          cartItem.orderdetail &&
          Array.isArray(cartItem.orderdetail)
        ) {
          for (let i = 0; i < cartItem.orderdetail.length; i++) {
            const orderDetail = cartItem.orderdetail[i];
            if (orderDetail && orderDetail.amount && orderDetail.quantity) {
              total = total + orderDetail.amount * orderDetail.quantity;
            }
          }
        }
      });
    }
    return total;
  }

  getSubTotalFromTotalandServiceCharges = () => {
    const { cartList } = this.state || {};
    let subTotal = 0;
    const total = this.getTotalofCart(cartList);
    const serviceChargeAmount = this.getServiceChargesBasedOnTotalAmount();
    subTotal = total + serviceChargeAmount;
    return subTotal;
  };

  getShippingPriceFromCart() {
    const { cartList } = this.state;
    let total = 0;
    if (cartList && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        if (cartList[i] && cartList[i].shippingprice) {
          total = cartList[i].shippingprice;
        }
      }
    }
    return total;
  }

  getProductIds = (cartList) => {
    let productIds = "";
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      cartList.forEach((cartItem) => {
        if (
          cartItem &&
          cartItem.orderdetails &&
          Array.isArray(cartItem.orderdetails)
        ) {
          for (let i = 0; i < cartItem.orderdetails.length; i++) {
            const orderDetail = cartItem.orderdetails[i];
            if (orderDetail && orderDetail.productId) {
              productIds = productIds.concat(`, ${orderDetail.productId}`);
            }
          }
        }
        // Also check for orderdetail (singular) for backward compatibility
        if (
          cartItem &&
          cartItem.orderdetail &&
          Array.isArray(cartItem.orderdetail)
        ) {
          for (let i = 0; i < cartItem.orderdetail.length; i++) {
            const orderDetail = cartItem.orderdetail[i];
            if (orderDetail && orderDetail.productId) {
              productIds = productIds.concat(`, ${orderDetail.productId}`);
            }
          }
        }
      });
    }
    return productIds;
  };

  getOrderId(cartList) {
    let orderId = "";
    if (cartList && cartList.length > 0 && cartList[0] && cartList[0].id) {
      orderId = cartList[0].id;
    }
    return orderId;
  }

  getTotalProductItems = () => {
    let totalProductItems = "";
    const { cartList } = this.state;
    if (cartList && cartList.length > 0) {
      const [product] = cartList;
      if (product && product.totalitems) {
        totalProductItems = product.totalitems;
      }
    }
    return totalProductItems;
  };

  // Helper method to get all order details from cart
  getAllOrderDetails = () => {
    const { cartList } = this.state;
    let allOrderDetails = [];

    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      cartList.forEach((cartItem) => {
        if (
          cartItem &&
          cartItem.orderdetails &&
          Array.isArray(cartItem.orderdetails)
        ) {
          allOrderDetails = allOrderDetails.concat(cartItem.orderdetails);
        }
        // Also check for orderdetail (singular) for backward compatibility
        if (
          cartItem &&
          cartItem.orderdetail &&
          Array.isArray(cartItem.orderdetail)
        ) {
          allOrderDetails = allOrderDetails.concat(cartItem.orderdetail);
        }
      });
    }

    return allOrderDetails;
  };

  onChangeOfPaymentMethod = (paymentMethod) => {
    console.log("=== PAYMENT METHOD CHANGE ===");
    console.log("Selected payment method:", paymentMethod);
    console.log("Previous payment method:", this.state.paymentMethod);
    console.log("Current state before change:", {
      paymentMethod: this.state.paymentMethod,
      isPlaceOrderButtonDisable: this.state.isPlaceOrderButtonDisable,
    });

    if (paymentMethod === "Cash On Delivery") {
      console.log("Setting Cash On Delivery payment method");
      this.setState({ paymentMethod, isPlaceOrderButtonDisable: false }, () => {
        console.log("State updated for Cash On Delivery");
      });
    }
    if (paymentMethod === "Paytm") {
      console.log("Setting Paytm payment method");
      this.setState({ paymentMethod, isPlaceOrderButtonDisable: false }, () => {
        console.log("State updated for Paytm");
      });
    }
    if (paymentMethod === "RazorPay") {
      console.log("Setting RazorPay payment method");
      this.setState({ paymentMethod, isPlaceOrderButtonDisable: false }, () => {
        console.log("State updated for RazorPay");
      });
    }

    if (paymentMethod === "PayU") {
      console.log("Setting PayU payment method");
      this.setState({ paymentMethod, isPlaceOrderButtonDisable: false }, () => {
        console.log("State updated for PayU");
      });
    }

    if (paymentMethod === "GooglePay") {
      console.log("Setting GooglePay payment method");
      this.setState({ paymentMethod }, () => {
        console.log("State updated for GooglePay");
      });
    }

    if (paymentMethod === "Paypal") {
      console.log("Setting Paypal payment method");
      this.setState({ paymentMethod }, () => {
        console.log("State updated for Paypal");
      });
    }

    if (paymentMethod === "Sadad") {
      console.log("Setting Sadad payment method");
      this.setState({ paymentMethod, isPlaceOrderButtonDisable: false }, () => {
        console.log("State updated for Sadad");
      });
    }

    console.log("Final state after change:", {
      paymentMethod: this.state.paymentMethod,
      isPlaceOrderButtonDisable: this.state.isPlaceOrderButtonDisable,
    });
    console.log("=== PAYMENT METHOD CHANGE END ===");
  };

  appendHandler(config) {
    const newConfig = { ...config };

    newConfig.handler = {
      notifyMerchant: this.notifyMerchantHandler,
    };

    return newConfig;
  }

  notifyMerchantHandler = (eventType, data) => {
    console.log("MERCHANT NOTIFY LOG", data);
    if (
      data &&
      data.body &&
      data.body.content &&
      data.body.content.STATUS === "TXN_FAILURE"
    ) {
      this.loadErrorMessageAnimation(data.body.content.RESPMSG);
    }
    if (
      data &&
      data.body &&
      data.body.resultInfo &&
      data.body.resultInfo.resultStatus === "F" &&
      data.body.resultInfo.resultCode === "1006"
    ) {
      this.loadErrorMessageAnimation(data.body.resultInfo.resultMsg);
    }
    if (
      data &&
      data.body &&
      data.body.resultInfo &&
      data.body.resultInfo.resultStatus === "F" &&
      data.body.resultInfo.resultCode !== "1006"
    ) {
      this.loadErrorMessageAnimation(data.body.resultInfo.resultMsg);
    }
  };

  // PaytM
  loadCheckoutScript = () => {
    const { paymentDetails } = this.state;

    const paytmPaymentMethodDetails = paymentDetails[0].text.filter(
      (paymentMethods) => {
        return paymentMethods.name === "Paytm";
      }
    );
    const mId = paytmPaymentMethodDetails[0].config.PaytmMerchantID;

    // Development URL
    // const url =
    //   "https://securegw-stage.paytm.in/merchantpgpui/checkoutjs/merchants/";

    // Production URL
    const url = "https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/";

    const scriptElement = document.createElement("script");
    scriptElement.async = true;
    scriptElement.src = url.concat(mId);
    scriptElement.type = "application/javascript";
    scriptElement.onload = () => {
      const checkoutJsInstance = this.getCheckoutJsObj();

      if (checkoutJsInstance && checkoutJsInstance.onLoad) {
        checkoutJsInstance.onLoad(() => {
          this.setState({
            checkoutJsInstance,
          });
        });
      } else {
        console.error(SSR_SIMULATE + "onload not available!");
      }
    };
    scriptElement.onerror = (error) => {
      console.error("SSR Simulate: script load fail!");
    };
    document.body.appendChild(scriptElement);
    this.setState({ isScriptLoading: true });
  };

  getCheckoutJsObj() {
    if (window && window.Paytm && window.Paytm.CheckoutJS) {
      return window.Paytm.CheckoutJS;
    } else {
      console.error(SSR_SIMULATE + "Checkout instance not found!");
    }

    return null;
  }

  renderServiceChargesLable = (serviceCharges) => {
    const { status, text = "" } = serviceCharges || {};
    if (status === 1) {
      const serviceChargeList = JSON.parse(text) || {};
      if (serviceChargeList) {
        const [labelObj] = serviceChargeList.filter((sc) => sc.key === "label");
        return labelObj.value;
      }
    }
    return "";
  };

  getServiceChargesBasedOnTotalAmount = () => {
    const { cartList, serviceCharges } = this.state || [];
    const { status, text } = serviceCharges || {};
    let serviceChargesAmount = 0;

    if (status === 1) {
      const serviceChargeList = JSON.parse(text) || {};
      if (serviceChargeList) {
        const [isPercentageObj] = serviceChargeList.filter(
          (sc) => sc.key === "isPercentage"
        );
        const [percentageObj] = serviceChargeList.filter(
          (sc) => sc.key === "percentage"
        );
        const [amountObj] = serviceChargeList.filter(
          (sc) => sc.key === "amount"
        );
        if (isPercentageObj && isPercentageObj.value) {
          const totalAmount = this.getTotalofCart(cartList);
          serviceChargesAmount = (totalAmount * percentageObj.value) / 100;
        }
        if (isPercentageObj && !isPercentageObj.value) {
          serviceChargesAmount = parseFloat(amountObj.value);
        }
      }
    }
    return serviceChargesAmount;
  };

  rednerBillingAndShippingAddress = (billingaddressObj, shippingaddressObj) => {
    // normalize shipping addresses into an array
    const shippingList = shippingaddressObj
      ? Array.isArray(shippingaddressObj)
        ? shippingaddressObj
        : [shippingaddressObj]
      : [];

    return (
      <>
        <div className="row">
          <div className="checkout-box col-12">
            {/* Billing summary */}
            <div className="col-12 f22 mt-2">
              <ul className="order-detail">
                <li className="mb-2 d-block" style={{ fontWeight: 550 }}>
                  {(billingaddressObj && billingaddressObj.name) || ""}
                  {billingaddressObj && billingaddressObj.mobile
                    ? " - " + billingaddressObj.mobile
                    : ""}
                </li>
                {billingaddressObj && billingaddressObj.email && (
                  <li className="mb-2 d-block">{billingaddressObj.email}</li>
                )}
                {billingaddressObj && billingaddressObj.companyname && (
                  <li className="mb-2 d-block">
                    {billingaddressObj.companyname}
                  </li>
                )}
                {billingaddressObj && billingaddressObj.gstin && (
                  <li className="mb-2 d-block">{billingaddressObj.gstin}</li>
                )}
                {billingaddressObj &&
                  (billingaddressObj.addressline1 ||
                    billingaddressObj.addressline2) && (
                    <li className="mb-2 d-block">
                      {billingaddressObj.addressline1 ||
                        billingaddressObj.address1}
                      {billingaddressObj.addressline2
                        ? ", " + billingaddressObj.addressline2
                        : ""}
                      {billingaddressObj.city
                        ? ", " + billingaddressObj.city
                        : ""}
                      {billingaddressObj.state
                        ? ", " + billingaddressObj.state
                        : ""}
                      {billingaddressObj.zipcode
                        ? " - " + billingaddressObj.zipcode
                        : ""}
                    </li>
                  )}
              </ul>
            </div>

            {/* Shipping addresses list (selectable) */}
            <div className="col-12 f22 mt-2">
              <ul className="order-detail">
                {shippingList.length === 0 && (
                  <li className="mb-2 d-block">No shipping address found</li>
                )}

                {shippingList.map((addr) => {
                  const checked =
                    this.state.selectedShippingAddressId === addr.id ||
                    (this.state.selectedShippingAddressId === null &&
                      !!addr.isdefault);

                  return (
                    <li
                      key={addr.id || JSON.stringify(addr)}
                      className="mb-2 d-block"
                      style={{
                        display: "flex",
                        gap: 12,
                        alignItems: "flex-start",
                      }}
                    >
                      <input
                        type="radio"
                        name="shipping-address"
                        checked={!!checked}
                        onChange={() =>
                          this.setState({ selectedShippingAddressId: addr.id })
                        }
                      />
                      <div>
                        <div style={{ fontWeight: 550 }}>
                          {addr.name} -{" "}
                          {addr.phone || addr.cellnumber || addr.mobile}
                        </div>
                        <div style={{ fontSize: 14, color: "#444" }}>
                          {addr.addressline1 || addr.address1 || ""}
                          {addr.addressline2 ? `, ${addr.addressline2}` : ""}
                          {addr.city ? `, ${addr.city}` : ""}
                          {addr.state ? `, ${addr.state}` : ""}
                          {addr.zipcode ? ` - ${addr.zipcode}` : ""}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  };
  renderNoBillingAddress = () => {
    const { isInquiry } = this.props;
    if (isInquiry) {
      return <div />;
    }
    return (
      <div>
        <section className="cart-section section-b-space">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  {!isInquiry && (
                    <div className="col-sm-12 empty-cart-cls text-center">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/icon/address.png`}
                        className="img-fluid mb-4"
                        alt=""
                      />
                      <div>
                        <h3>
                          <strong>
                            {getValueFromLanguageObject("str_no_address_found")
                              ? getValueFromLanguageObject(
                                  "str_no_address_found"
                                )
                              : "No Billing/Shipping Address Found in your account."}
                          </strong>
                        </h3>
                        <h4>
                          {getValueFromLanguageObject(
                            "str_add_billing_addresss"
                          )
                            ? getValueFromLanguageObject(
                                "str_add_billing_addresss"
                              )
                            : "Add Billing/Shipping Address."}
                        </h4>
                      </div>

                      <button
                        type="button"
                        className="btn-solid btn mobile-btn-block mt-2"
                        onClick={() => {
                          this.setState({
                            isAddBillingDetailModalVisible: true,
                          });
                        }}
                      >
                        {getValueFromLanguageObject("add_address")
                          ? getValueFromLanguageObject("add_address")
                          : "Add Address"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  render() {
    const { symbol, isInquiry } = this.props;
    const {
      cartList,
      // countryList,
      // stateList,
      // cityList,
      // shippingCountryList,
      // shippingStateList,
      // shippingCityList,
      isLoading,
      isMerchantGSTEnable,
      paymentDetails,
      paymentMethod,
      isPaymentDone,
      orderViaWhatsapp,
      AppTitle,
      currentCatelogueType,
      userDetails,
      isAddBillingDetailModalVisible,
      isEditBillingDetailModalVisible,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      sadadPaymentConfig,
      isOpenPayWithSadad,
      sadadPaymentChecksum,
      isHidePlaceOrderButton,
      serviceCharges,
      showConfirmOrderDialog,
    } = this.state;

    const { billingaddress, shippingaddress } = userDetails;
    const billingaddressObj = billingaddress
      ? JSON.parse(billingaddress)
      : null;
    console.log("Billing Address:", billingaddressObj);
    const shippingaddressObj = shippingaddress
      ? JSON.parse(shippingaddress)
      : null;

    const subTotal = this.getSubTotalFromTotalandServiceCharges();

    return (
      <div>
        {/*SEO Support*/}
        <Helmet>
          <title>
            {AppTitle} |{" "}
            {getValueFromLanguageObject("str_checkout_page")
              ? getValueFromLanguageObject("str_checkout_page")
              : "CheckOut Page"}
          </title>
          <meta
            name="description"
            content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses."
          />
        </Helmet>
        {/*SEO Support End */}

        <Breadcrumb
          title={
            getValueFromLanguageObject("checkout")
              ? getValueFromLanguageObject("checkout")
              : "CheckOut"
          }
        />

        {isAddBillingDetailModalVisible && (
          <AddBillingAddressModal
            isAddBillingDetailModalVisible={isAddBillingDetailModalVisible}
            onCloseModalAddBillingDetail={() => {
              this.setState({ isAddBillingDetailModalVisible: false }, () => {
                this.initUserDetails();
              });
            }}
          />
        )}

        {isEditBillingDetailModalVisible && (
          <EditBillingAddressModal
            isEditBillingDetailModalVisible={isEditBillingDetailModalVisible}
            onCloseModalEditBillingDetail={() => {
              this.setState({ isEditBillingDetailModalVisible: false }, () => {
                this.initUserDetails();
              });
            }}
          />
        )}

        <section className="section-b-space">
          <div className="container">
            <div className="checkout-page">
              <div className="checkout-form">
                <form>
                  <div className="checkout row justify-content-center">
                    {!isInquiry && (
                      <div className="col-lg-6 col-sm-12 col-xs-12">
                        <div className="row">
                          {/* <div className="checkout-title col-md-12 mb-0">
                            <h5>
                              {getValueFromLanguageObject("str_order_notes")
                                ? getValueFromLanguageObject("str_order_notes")
                                : "Order Notes"}
                            </h5>
                          </div> */}
                          {/* Order notes input removed here — rendered below in a styled card */}
                        </div>

                        {/* Address selection removed per design — only Order Notes shown */}
                        <div className="card p-3 mb-3">
                          <label style={{ fontWeight: 600, marginBottom: 8 }}>
                            {getValueFromLanguageObject("str_order_notes")
                              ? getValueFromLanguageObject("str_order_notes")
                              : "Order Notes"}
                          </label>
                          <input
                            type="text"
                            name="orderNotes"
                            value={this.state.orderNotes}
                            onChange={this.onChangeOfOrderNotes}
                            placeholder={
                              getValueFromLanguageObject("str_enter_order_notes")
                                ? getValueFromLanguageObject(
                                    "str_enter_order_notes"
                                  )
                                : "Enter Order Notes"
                            }
                            style={{ width: "100%", padding: "10px", borderRadius: 6, border: "1px solid #e5e5e5" }}
                          />
                        </div>
                      </div>
                    )}

                    {isInquiry && (
                      <div className="col-lg-6 col-sm-12 col-xs-12">
                        <div className="checkout-details">
                          <div className="order-box">
                            <div className="title-box">
                              <div>
                                {getValueFromLanguageObject("str_product")
                                  ? getValueFromLanguageObject("str_product")
                                  : "Product"}
                              </div>
                            </div>
                            <ul className="qty row">
                              {this.getAllOrderDetails().map((d, index) => {
                                return (
                                  <li key={index} className="col-md-12">
                                    <div className="row">
                                      <div className="col-md-9">
                                        <p>
                                          {d.products && d.products.name}{" "}
                                          {d.products && d.products.name}
                                        </p>
                                      </div>
                                      <div className="col-md-3">
                                        <p>Qty : {d.quantity}</p>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                          <div className="text-right">
                            {orderViaWhatsapp && orderViaWhatsapp.status === 1 && (
                              <button
                                type="button"
                                className="btn-solid-wp btn mobile-btn-block"
                                onClick={() => this.onClickOfOrderViaWhatsApp()}
                              >
                                {getValueFromLanguageObject(
                                  "str_inquiry_via_whatsapp"
                                )
                                  ? getValueFromLanguageObject(
                                      "str_inquiry_via_whatsapp"
                                    )
                                  : "Inquiry Via WhatsApp"}
                              </button>
                            )}
                            <button
                              type="button"
                              className="btn-solid btn mobile-btn-block"
                              onClick={() => this.placeAnInquiry()}
                            >
                              {getValueFromLanguageObject("str_place_inquiry")
                                ? getValueFromLanguageObject(
                                    "str_place_inquiry"
                                  )
                                : "Place Inquiry"}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {!isInquiry && (
                      <div className="col-lg-6 col-sm-12 col-xs-12">
                        {/* checkout details */}

                        <div className="checkout-details card p-3" style={{borderRadius:8}}>
                          <div className="order-box">
                            <div className="title-box">
                              <div>
                                {getValueFromLanguageObject("str_product")
                                  ? getValueFromLanguageObject("str_product")
                                  : "Product"}{" "}
                                <span>
                                  {" "}
                                  {getValueFromLanguageObject("str_total")
                                    ? getValueFromLanguageObject("str_total")
                                    : "Total"}
                                </span>
                              </div>
                            </div>
                            <ul className="qty">
                              {this.getAllOrderDetails().map((d, index) => {
                                return (
                                  <li key={index}>
                                    {`${d.products &&
                                      d.products.name} (${formatPrice(
                                      d.amount
                                    )} × ${d.quantity}) `}
                                    <span>
                                      {formatPrice(d.quantity * d.amount)}
                                    </span>
                                  </li>
                                );
                              })}
                            </ul>
                            <ul className="sub-total">
                              <li>
                                {getValueFromLanguageObject("str_total")
                                  ? getValueFromLanguageObject("str_total")
                                  : "Total"}
                                <span className="count">
                                  {formatPrice(this.getTotalofCart(cartList))}
                                </span>
                              </li>
                              {serviceCharges && serviceCharges.status === 1 && (
                                <li>
                                  {`+ ${this.renderServiceChargesLable(
                                    serviceCharges
                                  )}`}
                                  <span className="count">
                                    {`${formatPrice(
                                      this.getServiceChargesBasedOnTotalAmount()
                                    )}`}
                                  </span>
                                </li>
                              )}

                              {/*
                              <li>
                                {"+ "}
                                {getValueFromLanguageObject("shipping_charges")
                                  ? getValueFromLanguageObject(
                                      "shipping_charges"
                                    )
                                  : "Shipping Charges"}
                                <span className="count">
                                  {`${formatPrice(
                                    this.getShippingCharges(subTotal)
                                  )}`}
                                </span>
                              </li>
                              */}
                              {isMerchantGSTEnable &&
                                currentCatelogueType &&
                                currentCatelogueType.registerallow !==
                                  "Catalogue_Jewellary" &&
                                this.state.merchantInfo.countryname ===
                                  "India" && (
                                  <li>
                                    {"+ "}
                                    {getValueFromLanguageObject("str_cgst")
                                      ? getValueFromLanguageObject("str_cgst")
                                      : "CGST"}
                                    {"("}
                                    {this.state.merchantInfo.CGST}
                                    {"%)"}
                                    <span className="count">
                                      {`${formatPrice(
                                        this.getCGSTFromTotal(subTotal)
                                      )}`}
                                    </span>
                                  </li>
                                )}
                              {isMerchantGSTEnable &&
                                currentCatelogueType &&
                                currentCatelogueType.registerallow !==
                                  "Catalogue_Jewellary" &&
                                this.state.merchantInfo.countryname ===
                                  "India" && (
                                  <li>
                                    {"+ "}{" "}
                                    {getValueFromLanguageObject("str_sgst")
                                      ? getValueFromLanguageObject("str_sgst")
                                      : "SGST"}{" "}
                                    {"("}
                                    {this.state.merchantInfo.SGST}
                                    {"%)"}
                                    <span className="count">
                                      {`${formatPrice(
                                        this.getSGSTFromTotal(subTotal)
                                      )}`}
                                    </span>
                                  </li>
                                )}

                              {isMerchantGSTEnable &&
                                currentCatelogueType &&
                                currentCatelogueType.registerallow !==
                                  "Catalogue_Jewellary" &&
                                this.state.merchantInfo.countryname !==
                                  "India" && (
                                  <li>
                                    {"+ "}
                                    {getValueFromLanguageObject("str_igst")
                                      ? getValueFromLanguageObject("str_igst")
                                      : "IGST"}
                                    {"("}
                                    {this.state.merchantInfo.IGST}
                                    {"%)"}
                                    <span className="count">
                                      {`${formatPrice(
                                        this.getIGSTFromTotal(subTotal)
                                      )}`}
                                    </span>
                                  </li>
                                )}

                              {/*
                              <li>
                                {"- "}
                                {getValueFromLanguageObject("discount")
                                  ? getValueFromLanguageObject("discount")
                                  : "Discount"}
                                <span className="count">
                                  {`${formatPrice(0)}`}
                                </span>
                              </li>
                              */}
                            </ul>
                            <ul className="total">
                              <li>
                                {getValueFromLanguageObject(
                                  "str_amount_payable_with_colun"
                                )
                                  ? getValueFromLanguageObject(
                                      "str_amount_payable_with_colun"
                                    )
                                  : "Amount Payable : "}
                                <span className="count">
                                  {formatPrice(
                                    this.getGrandTotal(
                                      subTotal,
                                      this.getCGSTFromTotal(subTotal),
                                      this.getSGSTFromTotal(subTotal),
                                      this.getIGSTFromTotal(subTotal),
                                      this.getShippingCharges(subTotal)
                                    )
                                  )}
                                </span>
                              </li>
                            </ul>
                          </div>

                          <div className="payment-box">
                              <div className="upper-box">
                                {(() => {
                                  // const shouldShowPaymentOptions =
                                  //   isHidePlaceOrderButton &&
                                  //   paymentDetails &&
                                  //   paymentDetails.length > 0 &&
                                  //   paymentDetails[0].status === 1;
                                  // if (shouldShowPaymentOptions) {
                                  //   return (
                                  //     <div className="payment-options">
                                  //       <div className="order-box mb-0">
                                  //         <div className="title-box border-0 pb-0 mb-3">
                                  //           {getValueFromLanguageObject("str_make_your_payment_via")
                                  //             ? getValueFromLanguageObject("str_make_your_payment_via")
                                  //             : "Make your payment via"}
                                  //         </div>
                                  //       </div>
                                  //       <ul>
                                  //         {paymentDetails &&
                                  //           paymentDetails.length > 0 &&
                                  //           paymentDetails[0].status === 1 &&
                                  //           paymentDetails[0].text &&
                                  //           Array.isArray(
                                  //             paymentDetails[0].text
                                  //           ) &&
                                  //           paymentDetails[0].text.length > 0 &&
                                  //           paymentDetails[0].text.map(
                                  //             (paymentOption, index) => {
                                  //               console.log(
                                  //                 `Rendering payment option ${index +
                                  //                   1}:`,
                                  //                 {
                                  //                   name: paymentOption.name,
                                  //                   status:
                                  //                     paymentOption.status,
                                  //                   willRender:
                                  //                     paymentOption.status ===
                                  //                     1,
                                  //                 }
                                  //               );
                                  //               return paymentOption.status ===
                                  //                 1 ? (
                                  //                 <li key={paymentOption.name}>
                                  //                   <div className="radio-option">
                                  //                     <input
                                  //                       type="radio"
                                  //                       name="payment-group"
                                  //                       id={paymentOption.name}
                                  //                       onClick={() => {
                                  //                         console.log(
                                  //                           "Payment method selected:",
                                  //                           paymentOption.name
                                  //                         );
                                  //                         this.onChangeOfPaymentMethod(
                                  //                           paymentOption.name
                                  //                         );
                                  //                       }}
                                  //                       checked={
                                  //                         this.state
                                  //                           .paymentMethod ===
                                  //                         paymentOption.name
                                  //                           ? true
                                  //                           : false
                                  //                       }
                                  //                     />
                                  //                     <label
                                  //                       htmlFor={
                                  //                         paymentOption.name
                                  //                       }
                                  //                       style={{
                                  //                         color: "#444444",
                                  //                       }}
                                  //                     >
                                  //                       {paymentOption.name}
                                  //                       <span className="image" />
                                  //                     </label>
                                  //                   </div>
                                  //                 </li>
                                  //               ) : (
                                  //                 <React.Fragment
                                  //                   key={paymentOption.name}
                                  //                 >
                                  //                   {console.log(
                                  //                     `Skipping disabled payment method: ${paymentOption.name}`
                                  //                   )}
                                  //                 </React.Fragment>
                                  //               );
                                  //             }
                                  //           )}
                                  //       </ul>
                                  //     </div>
                                  //   );
                                  // } else {
                                  //   console.log(
                                  //     "Payment options not shown - conditions not met"
                                  //   );
                                  //   return null;
                                  // }
                                })()}
                              </div>
                              <div className="mb-2 text-right" />
                              {isHidePlaceOrderButton && (
                                <div className="text-right">
                                  {/* {orderViaWhatsapp &&
                                    orderViaWhatsapp.status === 1 && (
                                      <button
                                        type="button"
                                        className="btn-solid-wp btn mobile-btn-block"
                                        onClick={() =>
                                          this.onClickOfOrderViaWhatsApp()
                                        }
                                      >
                                        {getValueFromLanguageObject(
                                          "str_order_via_whatsapp"
                                        )
                                          ? getValueFromLanguageObject(
                                              "str_order_via_whatsapp"
                                            )
                                          : "Order Via WhatsApp"}
                                      </button>
                                    )} */}

                                  {/* <button
                                    type="button"
                                    className="btn-solid btn mobile-btn-block"
                                    onClick={() => this.onClickOfPlaceOrder()}
                                  >
                                    {getValueFromLanguageObject(
                                      "str_place_order"
                                    )
                                      ? getValueFromLanguageObject(
                                          "str_place_order"
                                        )
                                      : "Place Order"}
                                  </button> */}
                                </div>
                              )}

                              <div className="mb-2 text-right">
                                {!isHidePlaceOrderButton &&
                                  paymentMethod === "Paypal" &&
                                  this.state.payPalConfig &&
                                  this.state.payPalConfig.env && (
                                    <PaypalExpressBtn
                                      env={this.state.payPalConfig.env}
                                      client={this.state.payPalConfig.client}
                                      currency={
                                        this.state.payPalConfig.currency
                                      }
                                      total={this.state.payPalConfig.total}
                                      onError={this.onErrorOfPaypalPayment}
                                      onSuccess={this.onSuccessOfPaypalPayment}
                                      onCancel={this.onCancelOfPaypalPayment}
                                      shipping={1}
                                      style={{
                                        color: "gold",
                                        shape: "rect",
                                        size: "large",
                                        label: "pay",
                                      }}
                                    />
                                  )}
                                {!isHidePlaceOrderButton &&
                                  paymentMethod === "GooglePay" && (
                                    <GooglePayButton
                                      environment="PRODUCTION" // TEST, PRODUCTION
                                      buttonType="long"
                                      style={{ marginTop: "10px" }}
                                      paymentRequest={
                                        this.state.googlePayConfig
                                      }
                                      onLoadPaymentData={
                                        this.makeGooglePayPayment
                                      }
                                      onCancel={(cancel) => {
                                        console.log("cancel");
                                        console.log(cancel);
                                        this.loadErrorMessageAnimation(
                                          "Payment failed"
                                        );
                                        this.setState(
                                          { paymentResponse: cancel },
                                          () => {
                                            this.updatePaymentStatusGooglePay(
                                              3
                                            );
                                          }
                                        );
                                      }}
                                      onError={(error) => {
                                        console.log("error");
                                        console.log(error);
                                        this.loadErrorMessageAnimation(
                                          "Payment failed"
                                        );
                                        this.setState(
                                          { paymentResponse: error },
                                          () => {
                                            this.updatePaymentStatusGooglePay(
                                              3
                                            );
                                          }
                                        );
                                      }}
                                      onReadyToPayChange={(change) => {
                                        console.log("change");
                                        console.log(change);
                                      }}
                                      // onPaymentAuthorized={(auth) => {
                                      //   console.log("auth");
                                      //   console.log(auth);
                                      // }}
                                      // onPaymentDataChanged={(dataChange) => {
                                      //   console.log("dataChange");
                                      //   console.log(dataChange);
                                      // }}
                                    />
                                  )}
                              </div>
                            </div>
                          {/* )} */}
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>

          {this.state.paytmConfig &&
            this.state.paytmConfig.merchant &&
            this.state.paytmConfig.merchant.mid && (
              <div>
                <CheckoutProvider
                  config={this.state.paytmConfig}
                  checkoutJsInstance={this.state.checkoutJsInstance}
                  openInPopup={this.state.openInPopup}
                >
                  <Checkout />
                </CheckoutProvider>
              </div>
            )}
        </section>
        {/* Buttons with margin from left/right, centered like first image */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px", // or match your page content width
            margin: "40px auto 60px auto", // center container
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            className="btn"
            style={{
              background: "linear-gradient(180deg, #FFA726 0%, #F57C00 100%)",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              fontWeight: 600,
              fontSize: "14px",
              padding: "12px 32px",
              minWidth: "180px",
              boxShadow: "0 2px 8px rgba(255,167,38,0.15)",
              letterSpacing: "0.5px",
            }}
            onClick={() => this.props.history.push("/cart")}
          >
            BACK TO CART
          </button>
          <button
            type="button"
            className="btn"
            style={{
              background: "linear-gradient(180deg, #FFA726 0%, #F57C00 100%)",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              fontWeight: 600,
              fontSize: "14px",
              padding: "12px 32px",
              minWidth: "180px",
              boxShadow: "0 2px 8px rgba(255,167,38,0.15)",
              letterSpacing: "0.5px",
            }}
            onClick={() => this.onClickOfPlaceOrder()}
          >
            {getValueFromLanguageObject("str_place_order")
              ? getValueFromLanguageObject("str_place_order")
              : "PLACE ORDER"}
          </button>
        </div>

        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
      <Modal
  title={
    <div style={{ textAlign: "center", fontWeight: 700, fontSize: "20px", marginBottom: 0 }}>
      {/* Use a check-circle icon for confirmation */}
      <span
        style={{
          display: "inline-block",
          background: "#FFF3E0",
          borderRadius: "50%",
          padding: 12,
          marginBottom: 8,
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="#FFA726"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#FFF3E0"/>
          <path d="M9.5 16.2l-3.7-3.7 1.4-1.4 2.3 2.3 5.3-5.3 1.4 1.4-6.7 6.7z" fill="#FFA726"/>
        </svg>
      </span>
      <div style={{ marginTop: "8px" }}>Confirm Order</div>
      <div style={{ fontWeight: 400, fontSize: "15px", color: "#888", marginTop: 4 }}>
        Please review your order details before confirming.
      </div>
    </div>
  }
  centered
  open={this.state.showConfirmOrderDialog}
  onCancel={() => this.setState({ showConfirmOrderDialog: false })}
  onOk={this.handleConfirmPlaceOrder}
  okText="Confirm"
  cancelText="Cancel"
  okButtonProps={{
    style: {
      background: "#FF6A00",
      borderColor: "#FF6A00",
      color: "#fff",
      fontWeight: 700,
      fontSize: "14px",
      minWidth: "130px",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(255,167,38,0.15)",
    },
  }}
  cancelButtonProps={{
    style: {
      minWidth: "130px",
      borderRadius: "8px",
      fontWeight: 500,
      fontSize: "1.1rem",
    },
  }}
  bodyStyle={{
    textAlign: "center",
    padding: "32px",
    fontSize: "15px",
    fontWeight: 500,
    color: "#444",
    letterSpacing: "0.5px",
    borderRadius: "12px",
    background: "#FFF8F2",
  }}
  style={{
    borderRadius: "16px",
    overflow: "hidden",
    maxWidth: 420,
  }}
>
  <p style={{ marginBottom: 0, fontSize: "16px", fontWeight: 600 }}>
    Are you sure you want to place this order?
  </p>
</Modal>
        <SadadPaymentForm
          sadadPaymentConfig={sadadPaymentConfig}
          sadadPaymentChecksum={sadadPaymentChecksum}
          isOpenPayWithSadad={isOpenPayWithSadad}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  symbol: getCurrencySymbol(),
  isInquiry: state.settings.isInquiry,
});

export default connect(mapStateToProps, {
  notificationCounter: getNotificationCounter,
  isInquiryOrCart: isInquiryOrCart,
  setHeaderCounters,
})(withRouter(checkOut));
